import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const findingsTextNetwork = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "This section of the report provides mitigation steps for the identified vulnerabilities. The tables below list the vulnerabilities identified, their rating and the remediation actions to be performed. The scale as mentioned under “Observation Summary” has been used to rate the severity.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics:false
        }),
    ],
})
